import { render } from "./SupTiposChamadosView.vue?vue&type=template&id=6c36a97b"
import script from "./SupTiposChamadosView.vue?vue&type=script&lang=js"
export * from "./SupTiposChamadosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__